import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ModalBody } from "reactstrap";
import {
  getTeamSearchExpert,
  postTeam,
} from "../../../../../redux/team/action";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import Pagination from "../../../FindWork/SearchAll/AllPosts/CustomPagination/Pagination";
import { useStateContext } from "../../../../../Context/StateContext";

import ProfilePic from "../../../../../assests/imgs/Profileplaceholder.svg";
import PostNotFound from "../../../../CustomComponents/AllLoader/PostNotFound";
import ProfileImageWithFallback from "../../../../../common/ProfileImageWithFallback";
import CommonPagination from "../../../../Common/PaginationComponet/CommonPagination";
import CloseSearchbutton from "../../../ChatFunctionality/ChatComponent/CloseSearchbutton";

export default function TeamsInviteExpertModel({ setiniviteModel }) {
  const [searchtext, setSearchtext] = useState("");
  const [debouncedSearchtext, setDebouncedSearchtext] = useState(searchtext);
  const [loading, setLoading] = useState(false);
  const { state, setPageNumber } = useStateContext();
  const allexpert = useSelector(
    ({ team: { getteamsearchexperts } }) => getteamsearchexperts
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchtext(searchtext);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchtext]);

  useEffect(() => {
    const data = {
      searchtext: debouncedSearchtext,
      index: state.pageNumber
    }
    dispatch(getTeamSearchExpert(data));
  }, [debouncedSearchtext, dispatch, state.pageNumber]);

  const invite = (id) => {
    setLoading(true);

    const data = {
      type: 4,
      expert_id: id,
    };
    dispatch(postTeam(data));
    setiniviteModel(false);
    setLoading(true);
  };

  return (
    <>
      <div className="add-task">
        <h6>Invite experts to the team</h6>
        <button
          onClick={() => setiniviteModel(false)}
          className="btn close-button"
        >
          <img
            src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
            alt=""
          />
        </button>
      </div>
      <ModalBody>
        <div>
          <div className="form-group">
            <label>Search expert</label>
            <div className="search-bar">
              <input
                value={searchtext}
                type="text"
                className="form-control"
                onChange={(e) => setSearchtext(e.target.value)}
                placeholder="Search by name or email"
              />

              <button className="btn search-btn">
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/common/search-lg.svg`}
                  alt=""
                />
              </button>
                <CloseSearchbutton setSearchtext={setSearchtext} searchtext={searchtext} />

            </div>
          </div>
          {(allexpert && Array.isArray(allexpert.response) && allexpert.response?.length > 0) ?
            <div className="row exp-row">
              {allexpert && Array.isArray(allexpert.response) &&
                allexpert.response.map((item, index) => (
                  <div className="col-md-4" key={index}>
                    <div className="expert-details">
                      <ProfileImageWithFallback url={item.profile_image} />
                      <h4>
                        {item.first_name} {item?.last_name}
                      </h4>
                      <h6>{item.designation}</h6>
                      <div className="star">
                        <p>
                          <i className="fa-solid fa-star"></i>
                          {item?.expert_rating || 0} ({item?.comment_count} reviews)
                        </p>
                      </div>
                      <div className="skills">
                        {Array.isArray(item?.skills) &&
                          item?.skills.map((skill, skillIndex) => (
                            <div key={skillIndex}>
                              <p>{skill.title}</p>
                            </div>
                          ))}
                      </div>
                      <button
                        className="buttons border-button mx-auto"
                        onClick={() => invite(item.id)}
                        disabled={loading}
                      >
                        {loading ? (
                          <LoginLoaderButton />
                        ) : item?.invited == 1 ? (
                          "Already invited"
                        ) : item?.invited == 2 ? (
                          "Already requested"
                        ) : (
                          "Send Invite"
                        )}
                      </button>
                    </div>
                  </div>
                ))}
            </div>
            :
            <PostNotFound title={"No Expert/Company Found"} height={200} />
          }
        </div>
        {allexpert && <CommonPagination
          totalitemcounts={allexpert.count}
          size={12}
          pageNumber={state?.pageNumber}
          setPageNumber={setPageNumber}
        />}
      </ModalBody>
    </>
  );
}
